import { apiClient } from '@/core/api/client';
import type { TeamMemberWithPlanning, TeamPlanningApiResponse, TeamMember } from '../types/team.types';

export const teamAPI = {
  /**
   * Get all team members (admin + bureau)
   */
  getTeamMembers: async (): Promise<TeamMember[]> => {
    try {
      const response = await apiClient.get<{ success: boolean; data: TeamMember[] }>('/api/admin/team/members');
      if (response.success && response.data) {
        return response.data;
      }
      throw new Error('Failed to fetch team members');
    } catch (error) {
      console.error('Error fetching team members:', error);
      throw error;
    }
  },

  /**
   * Get team planning for a specific week
   * @param weekStart The Monday of the week (YYYY-MM-DD)
   */
  getTeamWeekPlanning: async (weekStart: string): Promise<TeamMemberWithPlanning[]> => {
    try {
      const response = await apiClient.get<TeamPlanningApiResponse>(`/api/admin/team/planning/week/${weekStart}`);
      if (response.success && response.data) {
        return response.data;
      }
      throw new Error(response.message || 'Failed to fetch team planning');
    } catch (error) {
      console.error('Error fetching team planning:', error);
      throw error;
    }
  }
};
